<template>
    <div class="container-fluid">
        <nav-header :navItems="[
            {
                name: 'Certificates',
                link: {
                    name: 'aUT Certificates',
                },
            },
            {
                name: `${certificate ? certificate.commonName : 'aUT Certificate'}`,
                link: {
                    name: 'aUT Certificate',
                    params: {
                        id: ` `,
                    },
                },
                closeTab: true,
                disable: true,
            },
        ]" pretitle="aqfer Universal Tag" :breadcrumbTitle="true" :editMode="editMode" @nav-close-clicked="closeClick">
            <template v-slot:breadcrumb-title>
                <nav aria-label="breadcrumb" class="header-title">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a @click="closeClick" href="#" class="h1">aUT Certificates</a>
                        </li>
                        <li class="breadcrumb-item active h1" aria-current="page">
                            {{ currentPage }}
                        </li>
                    </ol>
                </nav>
            </template>
            <template v-slot:header-button-content>
                <!-- Warnings, Get CSR, Upload signed certificate and Abort change now live
                     on the step they belong to, in the deployment rail on the certificate page. -->
                <div class="custom-btn-group">
                    <!-- A disabled button swallows hover, so the explanation hangs off the
                         wrapper instead. -->
                    <span v-if="certificate"
                        :title="disableRenew ? 'A change is already in progress. Abort it from the deployment card to renew.' : null">
                        <button :disabled="disableRenew" type="button" @click.prevent="this.showModal({ component: 'RenewCertificate', data: this.certificate })" class="btn btn-info">
                            Renew
                        </button>
                    </span>
                    <span v-if="certificate">
                        <button type="button" @click.prevent="onDeleteClick()" class="btn btn-danger">
                            Delete
                        </button>
                    </span>
                    <span v-else>
                        <button type="button" @click.prevent="showModal({ component: 'addCertificate', data: {screensize: 'xl'} })"
                            class="btn btn-primary">
                            Create Certificate
                        </button>
                    </span>
                </div>

            </template>
        </nav-header>
        <div>
            <router-view v-on:setCertificate="setCertificate" v-on:setCertDeploy="setCertDeploy">
            </router-view>
        </div>
    </div>
</template>

<script>
import NavHeader from "../../components/NavHeader.vue";
import { mapActions } from "vuex";
export default {
    components: { NavHeader },
    data() {
        return {
            certificate: null,
            certDeploy: null,
            currentPage: "Certificates",
        };
    },
    watch: {
        "$route.params.id": {
            handler: function (to, from) {
                if (!to) {
                    this.closeClick();
                }
            },
        },
        '$store.state.aut.deleteCertTrigger' :{
            handler(newValue) {
                this.closeClick()
            },
            deep: true
        }
    },
    computed:{
        disableRenew(){
            return this.certDeploy && !(this.certDeploy.deployment_state === 'cancelled' || this.certDeploy.deployment_state === 'completed' || this.certDeploy.deployment_state === 'error')
        }
    },
    methods: {
        ...mapActions({
            showModal: "showModal",
        }),
        setCertificate(certificate) {
            this.certificate = certificate;
        },
        setCertDeploy(certDeploy) {
            this.certDeploy = certDeploy;
        },
        closeClick() {
            this.certificate = null;
            this.certDeploy = null;
            this.$router.push({
                name: "aUT Certificates",
            });
        },
        onDeleteClick() {
            this.showModal({ component: "deleteCertificate", data: [this.certificate] })
        }
    },
};
</script>

<style scoped>
.custom-btn-group {
    display: flex;
    align-items: center;
}

.btn {
    margin-right: 12px;
}
</style>
